var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-menu",
    {
      staticClass: "el-menu-steps",
      attrs: {
        "default-active": _vm.activeStepStr,
        mode: "horizontal",
        "background-color": "#020a15",
        "text-color": "#fff",
        "active-text-color": "#86C79C",
      },
      on: { select: _vm.handleSelect },
    },
    [
      _c(
        "el-menu-item",
        { attrs: { index: "2", disabled: !_vm.allowedSteps[0] } },
        [
          _c("div", { staticClass: "el-menu-steps step-id" }, [
            _vm._v("Step 1"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "el-menu-steps step-label" }, [
            _vm._v(_vm._s(_vm.stepNames[0])),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-menu-item",
        { attrs: { index: "2", disabled: !_vm.allowedSteps[1] } },
        [
          _c("div", { staticClass: "el-menu-steps step-id" }, [
            _vm._v("Step 2"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "el-menu-steps step-label" }, [
            _vm._v(_vm._s(_vm.stepNames[1])),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-menu-item",
        { attrs: { index: "3", disabled: !_vm.allowedSteps[2] } },
        [
          _c("div", { staticClass: "el-menu-steps step-id" }, [
            _vm._v("Step 3"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "el-menu-steps step-label" }, [
            _vm._v(_vm._s(_vm.stepNames[2])),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-menu-item",
        { attrs: { index: "4", disabled: !_vm.allowedSteps[3] } },
        [
          _c("div", { staticClass: "el-menu-steps step-id" }, [
            _vm._v("Step 4"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "el-menu-steps step-label" }, [
            _vm._v(_vm._s(_vm.stepNames[3])),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }